export const STORY_PRE_PUBLISH_CHECKS = [
    {
        id: 'STORY_TRANS_HAS_TITLE',
        message: 'Title missing',
        check: (story) => Boolean(story.title?.trim()),
    },
    {
        id: 'STORY_TRANS_HAS_SUBTITLE',
        message: 'Subtitle missing',
        check: (story) => Boolean(story.subtitle?.trim()),
    },
    {
        id: 'STORY_TRANS_HAS_DESCRIPTION',
        message: 'Description missing',
        check: (story) => Boolean(story.description?.trim()),
    },
    {
        id: 'STORY_HAS_SLUG',
        message: 'Story slug missing',
        check: (story) => Boolean(story.slug?.trim()),
    },
    {
        id: 'SHOW_ENABLED',
        message: 'Show is disabled',
        check: (_story, show) => show.enabled === true,
    },
    {
        id: 'STORY_TRANS_HAS_DURATION',
        message: 'Duration missing for internal audio',
        autoFixFunction: 'gen-story-mixed-audio',
        autoFixPayload: { target: 'internal' },
        check: (story) => Boolean(story.durationSec && story.durationSec > 0),
    },
    {
        id: 'STORY_TRANS_HAS_DURATION_EXTERNAL',
        message: 'Duration missing for external audio',
        autoFixFunction: 'gen-story-mixed-audio',
        autoFixPayload: { target: 'external' },
        check: (story, show) => show.isDistributed !== true || Boolean(story.durationSecExternal && story.durationSecExternal > 0),
    },
    {
        id: 'STORY_TRANS_HAS_FILE_SIZE',
        message: 'File size missing for internal audio',
        autoFixFunction: 'gen-story-mixed-audio',
        autoFixPayload: { target: 'internal' },
        check: (story) => Boolean(story.fileSizeBytes && story.fileSizeBytes > 0),
    },
    {
        id: 'STORY_TRANS_HAS_FILE_SIZE_EXTERNAL',
        message: 'File size missing for external audio',
        autoFixFunction: 'gen-story-mixed-audio',
        autoFixPayload: { target: 'external' },
        check: (story, show) => show.isDistributed !== true || Boolean(story.fileSizeBytesExternal && story.fileSizeBytesExternal > 0),
    },
    {
        id: 'STORY_IMAGE_AVAILABLE',
        message: 'Story image missing',
        autoFixFunction: 'gen-story-image',
        check: (story) => Boolean(story.imageUpdatedAt),
    },
    {
        id: 'STORY_TRANS_AUDIO_AVAILABLE',
        message: 'Internal audio missing',
        autoFixFunction: 'gen-story-mixed-audio',
        autoFixPayload: { target: 'internal' },
        check: (story) => Boolean(story.mixedAudioUpdatedAt),
    },
    {
        id: 'STORY_TRANS_EXTERNAL_AUDIO_AVAILABLE',
        message: 'External audio missing',
        autoFixFunction: 'gen-story-mixed-audio',
        autoFixPayload: { target: 'external' },
        check: (story, show) => show.isDistributed !== true || Boolean(story.externalAudioUpdatedAt),
    },
];
export async function runStoryPrePublishChecks(story, show) {
    const issues = [];
    for (const checkDef of STORY_PRE_PUBLISH_CHECKS) {
        const passed = await checkDef.check(story, show);
        if (!passed) {
            issues.push({
                id: checkDef.id,
                message: checkDef.message,
                ...(checkDef.autoFixFunction && { autoFixFunction: checkDef.autoFixFunction }),
                ...(checkDef.autoFixPayload && { autoFixPayload: checkDef.autoFixPayload }),
            });
        }
    }
    return issues.sort((a, b) => a.id.localeCompare(b.id));
}
export function getFirstResolvableIssue(issues) {
    return issues.find((issue) => issue.autoFixFunction) ?? null;
}
export function hasIssuesChanged(oldIds, newIds) {
    if (oldIds == null) {
        return true;
    }
    if (oldIds.length !== newIds.length) {
        return true;
    }
    return oldIds.some((id, index) => id !== newIds[index]);
}
export function getIssueIds(issues) {
    return issues.map((issue) => issue.id);
}
export function getCheckDefinition(id) {
    return STORY_PRE_PUBLISH_CHECKS.find((check) => check.id === id);
}
//# sourceMappingURL=pre-publish-checks.js.map